(function () {
  function extractQty(str) {
    var m = (str || '').match(/\b(1|3|5)\b/);
    return m ? parseInt(m[1]) : 0;
  }

  // More robust match: qty=1 matches anything without 3 or 5
  function matchesQty(value, qty) {
    var s = (value || '').toLowerCase();
    if (qty === 1) return !(/\b[35]\b/.test(s));
    return new RegExp('\\b' + qty + '\\b').test(s);
  }

  function selectVariantByQty(qty) {
    var matched = false;

    // Button picker: radios are inside <variant-selects>
    document.querySelectorAll('variant-selects input[type="radio"]').forEach(function (r) {
      if (matched) return;
      if (matchesQty(r.value, qty)) {
        r.checked = true;
        // bubbles up to <variant-selects> which publishes the PubSub event
        r.dispatchEvent(new Event('change', { bubbles: true }));
        matched = true;
      }
    });

    // Dropdown picker fallback
    if (!matched) {
      document.querySelectorAll('variant-selects select').forEach(function (sel) {
        Array.from(sel.options).forEach(function (o) {
          if (matchesQty(o.value, qty) && !o.selected) {
            sel.value = o.value;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            matched = true;
          }
        });
      });
    }
  }

  function buildSlider(qtyEl) {
    if (qtyEl.dataset.sliderDone) return;
    qtyEl.dataset.sliderDone = '1';

    var numInput = qtyEl.querySelector('.quantity__input');
    if (!numInput) return;

    var min  = parseInt(numInput.getAttribute('data-min') || numInput.min) || 1;
    var max  = parseInt(numInput.getAttribute('data-max') || numInput.max) || 10;
    var step = parseInt(numInput.step) || 1;
    var val  = parseInt(numInput.value) || min;
    if (max <= min) max = min + 9;

    function fill(slider) {
      var pct = ((+slider.value - min) / (max - min)) * 100;
      slider.style.setProperty('--qty-fill', pct + '%');
    }

    var wrap = document.createElement('div');
    wrap.className = 'qty-slider-wrap';

    var slider = document.createElement('input');
    slider.type      = 'range';
    slider.className = 'qty-slider';
    slider.min       = min;
    slider.max       = max;
    slider.step      = step;
    slider.value     = val;
    slider.setAttribute('aria-label', 'Quantité');

    var display = document.createElement('span');
    display.className   = 'qty-slider-display';
    display.textContent = val;

    wrap.appendChild(slider);
    wrap.appendChild(display);
    qtyEl.parentNode.insertBefore(wrap, qtyEl);
    fill(slider);

    // ── Slider → input + pack variant activation ──
    slider.addEventListener('input', function () {
      var v = parseInt(slider.value);
      numInput.value      = v;
      display.textContent = v;
      fill(slider);
      numInput.dispatchEvent(new Event('change', { bubbles: true }));
      selectVariantByQty(v); // always try — matchesQty handles non-pack values gracefully
    });

    numInput.addEventListener('change', function () {
      var v = parseInt(numInput.value);
      if (!isNaN(v)) { slider.value = v; display.textContent = v; fill(slider); }
    });

    // ── Variant button click → slider update ──
    function syncFromVariant() {
      var el = document.querySelector('variant-selects [data-selected-variant]');
      if (!el) { setTimeout(syncFromVariant, 300); return; }
      function update() {
        try {
          var variant = JSON.parse(el.textContent || el.innerHTML);
          var q = extractQty(variant.title || '');
          if (q > 0 && parseInt(slider.value) !== q) {
            slider.value        = q;
            numInput.value      = q;
            display.textContent = q;
            fill(slider);
          }
        } catch (e) {}
      }
      update();
      new MutationObserver(update).observe(el, { childList: true, subtree: true, characterData: true });
    }
    syncFromVariant();
  }

  function init() {
    document.querySelectorAll('.product-form__quantity quantity-input').forEach(buildSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
